// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-prop {
  padding: 10px 20px;
}
.user-prop i {
  cursor: pointer;
  color: #ce6161;
  padding-right: 20px;
}
.controls {
  position: absolute;
  background: white;
  top: calc(50vh - 75px);
  left: calc(50vw - 150px);
  border-radius: 5px;
  width: 300px;
  height: 150px;
  box-shadow: 1px 2px 3px black;
  text-align: center;
  z-index: 100 !important;
}
.controls h3 {
  font-size: 18px;
  color: white;
  background: #ce6161;
  border-bottom: 1px solid black;
  padding: 10px;
  border-radius: 5px 5px 0 0;
}
.controls p {
  padding: 10px;
  padding-top: 0;
  margin: 0;
}
.controls input[value="continue"] {
  background: #54a54e;
  color: white;
}
.controls input[value="cancel"] {
  background: #8e9bb5;
  color: white;
}
.notice {
  font-size: 12px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(15, 26, 53, 0.3);
  z-index: 10;
}
form {
  padding-top: 15px;
  padding-left: 15px;
  background-color: #efeff7;
}
`, "",{"version":3,"sources":["webpack://./src/app/users-module/users-view/users-view.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AADF;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;AADF;AAGA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;AADF;AAGA;EACE,aAAA;EACA,cAAA;EACA,SAAA;AADF;AAGA;EACE,mBAAA;EACA,YAAA;AADF;AAGA;EACE,mBAAA;EACA,YAAA;AADF;AAGA;EACE,eAAA;AADF;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;EACA,WAAA;AADF;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;AADF","sourcesContent":["@import (reference) '../../../styles.less';\n\n.user-prop {\n  padding: 10px 20px;\n}\n.user-prop i {\n  cursor: pointer;\n  color: @red;\n  padding-right: 20px;\n}\n.controls {\n  position: absolute;\n  background: white;\n  top: ~\"calc(50vh - 75px)\";\n  left: ~\"calc(50vw - 150px)\";\n  border-radius: 5px;\n  width: 300px;\n  height: 150px;\n  box-shadow: 1px 2px 3px @darkshadow;\n  text-align: center;\n  z-index: 100 !important;\n}\n.controls h3 {\n  font-size: 18px;\n  color: white;\n  background: @red;\n  border-bottom: 1px solid black;\n  padding: 10px;\n  border-radius: 5px 5px 0 0;\n}\n.controls p {\n  padding: 10px;\n  padding-top: 0;\n  margin: 0;\n}\n.controls input[value=\"continue\"] {\n  background: @green;\n  color: white;\n}\n.controls input[value=\"cancel\"] {\n  background: @grey;\n  color: white;\n}\n.notice {\n  font-size: 12px;\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: @overlay;\n  z-index: 10;\n}\nform {\n  padding-top: 15px;\n  padding-left: 15px;\n  background-color: @ltpurple;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
